import { useWalletStore } from '@/stores/wallet';

// Gating dos botões Depositar/Sacar do Minha Conta V2, em paridade com o
// header antigo (Buttons.vue) e o card RealWallet:
// - userCanOnlyWithdraw: em exclusão/timeout/exceção o Depositar some.
// - canWithdraw: saque liberado pelo backend (withdrawEnabled) e com saldo real.
export default function useUserV2PaymentsGate() {
  const { userCanOnlyWithdraw } = useUserLimits();
  const { walletHasReal } = useWallet();
  const { realWallet } = storeToRefs(useWalletStore());

  const canWithdraw = computed<boolean>(
    () => !!realWallet.value.withdrawEnabled && walletHasReal.value,
  );

  return { userCanOnlyWithdraw, canWithdraw };
}
